/* eslint-disable camelcase */
import React from 'react';

import { secondaryNavLink } from './SecondaryNavStyles';

import ButtonLink from './ButtonLink';

import { createRandomId } from '../../../../../../util/createRandomId';

const onButtonClick = event => {
  if (event.currentTarget.dataset.name === 'Sign Up') {
    window.optimizely.push({
      type: 'event',
      eventName: 'clicked_signup_cta',
      tags: {
        action: 'click',
        category: 'top_nav',
        name: 'signup',
      },
    });

    window.analytics.track('Web Interaction', {
      action: 'click',
      category: 'top_nav',
      name: 'signup',
    });
  }
};

const SecondaryNavLinks = navigation => {
  const { primary_navigation_end_links } = navigation;

  return primary_navigation_end_links.map((item, i) => (
    <ButtonLink
      className={
        primary_navigation_end_links.length !== i + 1 ? 'is-primary is-outlined is-small' : 'is-primary is-small'
      }
      css={secondaryNavLink}
      linkTo={item.primary_navigation_end_link && item.primary_navigation_end_link.url}
      color="primary"
      outlined={primary_navigation_end_links.length !== i + 1}
      key={item.primary_navigation_end_link_text}
    >
      <span
        data-name={item.primary_navigation_end_link_text}
        onClick={onButtonClick}
        onKeyDown={onButtonClick}
        role="button"
        tabIndex={createRandomId()}
      >
        {item.primary_navigation_end_link_text}
      </span>
    </ButtonLink>
  ));
};

export default SecondaryNavLinks;
